<template>
    <section id="app-inventory-stock" class="content-wrapper">
        <!-- top page section -->
        <app-page-top-section :title="$t('stock')">
            <!-- <div class="dropdown d-inline-block btn-dropdown"
                 v-if="this.$can('import_stock')"
            >
                <button
                    class="btn btn-success dropdown-toggle ml-0 mr-2"
                    aria-expanded="false"
                    aria-haspopup="true"
                    data-toggle="dropdown"
                    type="button"
                >
                    {{ $t('action') }}
                </button> -->

                <!-- temporary action dropdown -->
                <!-- <div class="dropdown-menu">
                    <a class="dropdown-item d-flex align-items-center p-3"
                       v-if="this.$can('import_stock')"
                       href="#" @click="openImportStockDialog">
                        <app-icon class="size-15 mr-2" name="download"/>
                        {{ $t('import_stock') }}
                    </a>

                </div>
            </div> -->

            <app-default-button
                class="btn btn-primary"
                v-if="this.$can('create_lot')"
                :title="$addLabel('lot')"
                :url="('/lot/add')"/>
        </app-page-top-section>

        <app-table v-if="options.url" :id="table_id" class="table-striped tblFixHead" :options="options" @action="triggerAction" />

        <app-stock-create-edit-modal
            :value="showModal"
            @input="handleInputEvent"
            v-if="showModal"
        />

        <app-activation-alert-popup
            v-if="activationModalActive"
            @activation-popup-close="handleActivationPopupClose"
        />
        <app-stock-adjustment-create-edit-modal
            v-if="stockAdjustmentModalActive"
            v-model="stockAdjustmentModalActive"
            :item-to-adjust="itemToAdjust"
            @modal-close="stockAdjustmentModalActive = false"
        />

        <app-stock-detail-modal
            v-if="stockDetailModalActive"
            :variant-id="selectedVariantId"
            @updated="reloadStockTable"
            @modal-close="stockDetailModalActive = false"
        />

        <!--     import stock -->
        <stock-import-modal v-if="importDialog" @modal-close="closeImportDialog"/>

    </section>
</template>

<script>
import StockTableMixin from '../../Mixins/Stock/StockTableMixin';
import StockModal from './StockModal';
import StockImportModal from "./StockImportModal";
import StockDetailModal from "./StockDetailModal";
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {STOCK_ADJUSTMENTS} from "../../../Config/ApiUrl-CP";

export default {
    name: 'app-inventory-stock',
    mixins: [StockTableMixin],
    components: {
        'app-stock-modal': StockModal,
        StockImportModal,
        'app-stock-detail-modal': StockDetailModal
    },
    data() {
        return {
            importDialog: false,
            table_id: 'stock-table',
            stocks: '',
            showModal: false,
            stockAdjustmentModalActive: false,
            stockDetailModalActive: false,
            selectedVariantId: '',
            activationModalActive: false,
            itemToAdjust: '',
        };
    },
    methods: {
        openImportStockDialog() {
            return window.location.replace(urlGenerator('/import/stock'));
        },
        closeImportDialog() {
            this.importDialog = false
        },
        triggerAction(row, action, active) {
            switch (action.name) {
                case "show_stock_overview":
                    // rows are now variants directly (row.id); open the detail modal.
                    this.selectedVariantId = row.variant ? row.variant.id : row.id;
                    this.stockDetailModalActive = true;
                    break;
                case "stock_adjust":
                    this.itemToAdjust = row.variant_id;
                    this.stockAdjustmentModalActive = true;
                    break;
                default:
                    this.getAction(row, action, active)
            }
        },
        reloadStockTable() {
            this.$hub.$emit(`reload-${this.table_id}`);
        },
        openDetailFromName(variantId) {
            this.selectedVariantId = variantId;
            this.stockDetailModalActive = true;
        },
        handleInputEvent(emittedData) {
            this.showModal = emittedData;
        },
        handleActivationPopupClose() {
            $('#activation-alert-modal').modal('hide');
            this.activationModalActive = false;
        },
    },
    watch: {
        // when the Add/Deduct modal closes (after a save or cancel), refresh the
        // stock list so updated balances appear.
        stockAdjustmentModalActive(isOpen, wasOpen) {
            if (wasOpen && !isOpen) {
                this.$hub.$emit(`reload-${this.table_id}`);
            }
        },
    },
    mounted() {
        // clicking a product name in the list opens its detail modal
        this.$hub.$on('open-stock-detail', this.openDetailFromName);
    },
    beforeDestroy() {
        this.$hub.$off('open-stock-detail', this.openDetailFromName);
    },
};
</script>
<style>
.tblFixHead .table-responsive.custom-scrollbar { overflow: auto; height: 600px; padding-top: 0 !important;}
.tblFixHead .table-responsive.custom-scrollbar table { width: 1400px; }
.tblFixHead .table-responsive.custom-scrollbar table thead { position: sticky; top: 0; z-index: 2; background-color: #fff !important; }
.tblFixHead .table-responsive.custom-scrollbar table thead tr th:first-child { position: sticky; left: 0; z-index: 2;background-color: #fff !important; }
.tblFixHead .table-responsive.custom-scrollbar table tbody tr td:first-child { position: sticky; left: 0; z-index: 1; }
.tblFixHead .table-responsive.custom-scrollbar table thead th { padding-top: 2rem !important; }
.tblFixHead .table-responsive.custom-scrollbar table tbody tr:nth-child(even) td:first-child { background-color: #fff }
.tblFixHead .table-responsive.custom-scrollbar table tbody tr:nth-child(odd) td:first-child { background-color: #f2f2f2 }
</style>
